module.exports = __webpack_public_path__ + "static/media/j1.bee11636.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/journal/j1.jpg
// module id = 247
// module chunks = 0